import { z } from 'zod';

/**
 * Tax code returned by the tax-code API.
 */
export const zodTaxCodeSchema = z.object({
  code: z.string().nullable(),
  company: z.object({
    id: z.uuid(),
    logoUrl: z.string().nullish(),
    name: z.string().nullish(),
  }),
  createdBy: z.uuid(),
  createdOn: z.iso.datetime({ offset: true }),
  id: z.uuid(),
  isReverseCharge: z.boolean(),
  name: z.string(),
  rate: z.string(),
  updatedBy: z.uuid().nullable(),
  updatedOn: z.iso.datetime({ offset: true }),
});
